$(document).ready(() => {
  function setUrl() {
    const currentSlide = $(".blog .carousel__item.slick-current");
    const carouselButton = $(".blog .carousel__button");
    const carouselButtonLabel = $(".blog #carousel__button-label");
    carouselButton.attr("href", currentSlide.data("url"));
    if (carouselButtonLabel.length !== 0) {
      carouselButtonLabel[0].textContent = currentSlide.data("buttonLabel");
    }
  }
  $(".blog .carousel__slider").slick({
    infinite: true,
    dots: true,
    prevArrow: false,
    nextArrow: false,
  });
  $(".blog .carousel__slider").on("afterChange", () => {
    setUrl();
  });
  setUrl();

  $(".home .carousel__slider").slick({
    lazyLoad: "progressive",
    autoplay: false,
    autoplaySpeed: 8000,
    infinite: true,
    dots: true,
    prevArrow: false,
    nextArrow: false,
  });
  // $(".home.carousel .slick-dots").addClass("white");

  $(".home .carousel__slider").on(
    "beforeChange",
    (event, slick, currentSlide, nextSlide) => {
      if (nextSlide !== 2) {
        $(".home.carousel .slick-dots").removeClass("white");
      } else {
        $(".home.carousel .slick-dots").addClass("white");
      }

      if (
        nextSlide === 0 ||
        nextSlide === 1 ||
        nextSlide === 2 ||
        nextSlide === 3 ||
        nextSlide === 8
      ) {
        $(".marquee-text-1").css("display", "none");
        $(".marquee-text-2").css("display", "none");
        $(".marquee-text-3").css("display", "inline-flex");
        $(".marquee-text-4").css("display", "none");
        $(".marquee-text-5").css("display", "none");
        $(".marquee-text-6").css("display", "none");
        $(".carousel__marquee-arrow").css("opacity", "0");
        $(".carousel__marquee").css("opacity", "0");
      } else if (nextSlide === 4) {
        $(".marquee-text-1").css("display", "none");
        $(".marquee-text-2").css("display", "none");
        $(".marquee-text-3").css("display", "inline-flex");
        $(".marquee-text-4").css("display", "none");
        $(".marquee-text-5").css("display", "none");
        $(".marquee-text-6").css("display", "none");
        $(".carousel__marquee-arrow").css("opacity", "1");
        $(".carousel__marquee").css("opacity", "1");
      } else if (nextSlide === 5) {
        $(".marquee-text-1").css("display", "none");
        $(".marquee-text-2").css("display", "inline-flex");
        $(".marquee-text-3").css("display", "none");
        $(".marquee-text-4").css("display", "none");
        $(".marquee-text-5").css("display", "none");
        $(".marquee-text-6").css("display", "none");
        $(".carousel__marquee-arrow").css("opacity", "1");
        $(".carousel__marquee").css("opacity", "1");
      } else if (nextSlide === 6) {
        $(".marquee-text-1").css("display", "none");
        $(".marquee-text-2").css("display", "inline-flex");
        $(".marquee-text-3").css("display", "none");
        $(".marquee-text-4").css("display", "none");
        $(".marquee-text-5").css("display", "none");
        $(".marquee-text-6").css("display", "none");
        $(".carousel__marquee-arrow").css("opacity", "1");
        $(".carousel__marquee").css("opacity", "1");
      } else {
        $(".marquee-text-1").css("display", "inline-flex");
        $(".marquee-text-2").css("display", "none");
        $(".marquee-text-3").css("display", "none");
        $(".marquee-text-4").css("display", "none");
        $(".marquee-text-5").css("display", "none");
        $(".marquee-text-6").css("display", "none");
        $(".carousel__marquee-arrow").css("opacity", "1");
        $(".carousel__marquee").css("opacity", "1");
      }
      switch (nextSlide) {
        case 0:
          $(".carousel__marquee-wrapper").css("background", "#FFF0");
          $(".carousel__marquee-wrapper").css("opacity", "0");
          break;
        case 1:
          $(".carousel__marquee-wrapper").css("background", "#FFF0");
          $(".carousel__marquee-wrapper").css("opacity", "0");
          break;
        case 2:
          $(".carousel__marquee-wrapper").css("background", "#FFF0");
          $(".carousel__marquee-wrapper").css("opacity", "0");
          break;
        case 3:
          $(".carousel__marquee-wrapper").css("background", "#FFF0");
          $(".carousel__marquee-wrapper").css("opacity", "0");
          break;
        case 4:
          $(".carousel__marquee-wrapper").css("background", "#718EA8");
          $(".carousel__marquee-wrapper").css("opacity", "1");
          break;
        case 5:
          $(".carousel__marquee-wrapper").css("background", "#E8708C");
          $(".carousel__marquee-wrapper").css("opacity", "1");
          break;
        case 6:
          $(".carousel__marquee-wrapper").css("background", "#9794E7");
          $(".carousel__marquee-wrapper").css("opacity", "1");
          break;
        case 7:
          $(".carousel__marquee-wrapper").css("background", "#68647B");
          $(".carousel__marquee-wrapper").css("opacity", "1");
          break;
        case 8:
          $(".carousel__marquee-wrapper").css("background", "#FFF0");
          $(".carousel__marquee-wrapper").css("opacity", "0");
          break;
        case 9:
          $(".carousel__marquee-wrapper").css("background", "#FFF0");
          $(".carousel__marquee-wrapper").css("opacity", "0");
          break;
      }
    },
  );

  function animateBogoImages() {
    const PRODUCTS = {
      red: [
        {
          src: "/cdn/shop/files/red-metal-single.png?height=500",
          type: "metal",
        },
        { src: "/cdn/shop/files/red-card-single.png?height=500", type: "card" },
        { src: "/cdn/shop/files/red-bundle.png?height=500", type: "bundle" },
        { src: "/cdn/shop/files/red-thin-single.png?height=500", type: "thin" },
        {
          src: "/cdn/shop/files/red-classic-single.png?height=500",
          type: "classic",
        },
      ],
      white: [
        {
          src: "/cdn/shop/files/white-display-single.png?height=500",
          type: "display",
        },
        {
          src: "/cdn/shop/files/white-metal-single.png?height=500",
          type: "metal",
        },
        {
          src: "/cdn/shop/files/white-card-single.png?height=500",
          type: "card",
        },
        {
          src: "/cdn/shop/files/white-thin-single.png?height=500",
          type: "thin",
        },
        {
          src: "/cdn/shop/files/white-classic-single.png?height=500",
          type: "classic",
        },
      ],
      blue: [
        {
          src: "/cdn/shop/files/blue-display-single.png?height=500",
          type: "display",
        },
        {
          src: "/cdn/shop/files/blue-metal-single.png?height=500",
          type: "metal",
        },
        {
          src: "/cdn/shop/files/blue-card-single.png?height=500",
          type: "card",
        },
        {
          src: "/cdn/shop/files/blue-band-single.png?height=500",
          type: "band",
        },
        {
          src: "/cdn/shop/files/blue-thin-single.png?height=500",
          type: "thin",
        },
        {
          src: "/cdn/shop/files/blue-classic-single.png?height=500",
          type: "classic",
        },
      ],
    };

    const COLORS = ["red", "white", "blue"];

    const elements = {
      red: {
        desktop: $("#july-bogo-home-red"),
        mobile: $("#july-bogo-home-red-mobile"),
      },
      white: {
        desktop: $("#july-bogo-home-white"),
        mobile: $("#july-bogo-home-white-mobile"),
      },
      blue: {
        desktop: $("#july-bogo-home-blue"),
        mobile: $("#july-bogo-home-blue-mobile"),
      },
    };

    const currentIndex = { red: -1, white: -1, blue: -1 };
    let lastColor = null;

    Object.values(PRODUCTS)
      .flat()
      .forEach(({ src }) => {
        new Image().src = src;
      });

    function pickNextIndex(color) {
      const list = PRODUCTS[color];
      let next;
      do {
        next = Math.floor(Math.random() * list.length);
      } while (next === currentIndex[color] && list.length > 1);
      return next;
    }

    function swapImage(color) {
      const idx = pickNextIndex(color);
      currentIndex[color] = idx;

      const { src, type } = PRODUCTS[color][idx];
      const { desktop, mobile } = elements[color];

      desktop.attr("src", src).attr("data-type", type);
      mobile.attr("src", src).attr("data-type", type);
    }

    function pickNextColor() {
      const available = lastColor
        ? COLORS.filter((c) => c !== lastColor)
        : COLORS;
      return available[Math.floor(Math.random() * available.length)];
    }

    setInterval(() => {
      const color = pickNextColor();
      lastColor = color;
      swapImage(color);
    }, 2000);
  }
  animateBogoImages();
});
